import { Form, GroupItem, Item } from 'devextreme-react/form';
import { useAppSelector, useAppDispatch } from '../../../../contexts/hooks';

import Toolbar, { Item as ItemToolBar } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import { formatMessage } from 'devextreme/localization';
import { useEffect, useRef, useState } from 'react';

import { CustomFormControl } from '../../../../components/utils/form-render/FormRender';
//import { setHeightPanels } from '../../../../contexts/slices/config';

import { useScreenSize } from '../../../../utils/media-query';
import { LoadIndicator, ScrollView, SelectBox, TextBox, Tooltip } from 'devextreme-react';
import { newToast } from '../../../../components';
import { EditIcon, save } from '../../../../images/icons';
import { setMode, updateFieldQuotation } from '../../../../contexts/slices/quotations';

const Index = ({ onClickSave, onClickCancel }) => {
  const dispatch = useAppDispatch();
  
  const mode = useAppSelector((x) => x.globalQuotation.Mode);
  const profileCardRef = useRef<HTMLDivElement>(null);
  const ColumnsOrdersCount = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsOrdersCount')[0])?.Cgn_Resultado;
  const data = useAppSelector((x) => x.globalQuotation.Quotation);
  const PatientData = useAppSelector((x) => x.globalQuotation.PatientData);
  const lstServicios = useAppSelector((x) => x.configuration.Data?.ComboBox.find((x) => x.Name === 'SysA_Servicios')?.Data) || [];
  const AllowCreateOrdersAnotherLocation: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'AllowCreateOrdersAnotherLocation')[0].Cgn_Resultado) || 'false');

  const [lstContratos, setLstContratos] = useState<any[]>([]);
  const { isLarge, isMedium } = useScreenSize();
  const Loading = useAppSelector((x) => x.globalQuotation.Loading);
  const Combobox = useAppSelector((x) => x.configuration.Data?.ComboBox);

  const info = useAppSelector((x) => x.configuration.Data?.SystemFields)
    ?.filter((x) => x.Dfc_Tabla === 'Ordenes' && x.Dfc_Estado === true)
    .sort((a, b) => a.Dfc_Orden - b.Dfc_Orden);

  useEffect(() => {
    if (info && info.length > 0 && info.filter((x) => x.Dfc_Equivalencia === 'Ord_Cn_Id').length > 0) {
      const contratos = info.filter((x) => x.Dfc_Equivalencia === 'Ord_Cn_Id')[0].Dfc_Tbc_Id;
      const contratosData = Combobox?.find((x) => x.Id === contratos)?.Data || [];
      setLstContratos(contratosData);
      return;
    }
    setLstContratos([]);
  }, []);

  const handleEditClick = () => {
    dispatch(setMode({ mode: 'update' }));
  };

  const onSaveClick = () => {
    // Validar campos de ordenes.
    // if (!data['Cz_Cn_Id']) {
    //   newToast('INFO', `El campo 'Contrato' es obligatorio`, 4);
    //   return;
    // }

    for (const element of info ?? []) {
      if (element.Dfc_Requerido && !element.Dfc_Dinamico && !data[element.Dfc_Equivalencia]) {
        if (element.Dfc_Equivalencia === 'Ord_Cn_Id' && data['Cz_Cn_Id']) {
          continue; // Si es contrato, no lo validamos si ya está seleccionado
        }
        newToast('INFO', `El campo '${element.Dfc_Label}' es obligatorio`, 4);
        return; // Salir de la función
      }
      // Ahora los dinámicos
      if (element.Dfc_Requerido && element.Dfc_Dinamico && !data.AditionalFields[element.Dfc_Equivalencia]) {
        newToast('INFO', `El campo '${element.Dfc_Label}' es obligatorio`, 4);
        return; // Salir de la función
      }
    }

    //Luego validamos que paciente esté asignado
    if (!PatientData || !PatientData.Pc_Id) {
      newToast('INFO', formatMessage('OrdNotificationPatientReq'), 4);
      return;
    }

    onClickSave();
  };

  const onCancelClick = () => {
    if (mode === 'update') {
      dispatch(setMode({ mode: 'view' }));
      return;
    }
    if (mode === 'new') {
      onClickCancel();
      return;
    }
    //findOrder(undefined, undefined, setLoading);
    //handleEditClick();
  };

  const setData = (field, castMode) => (value: string | number) => {
    dispatch(updateFieldQuotation({ field, castMode, value: value }));
  };

  return (
    <div className='profile-card' style={{ height: '100%', overflow: 'hidden' }}>
      <div className='profile-card-panel' style={{ height: '180px' }} ref={profileCardRef}>
        <div className='profile-card-panel-header'>
          <Toolbar>
            <ItemToolBar location='before' visible={isLarge || isMedium}>
              <span className='title-text'>Encabezado de la cotización</span>
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='after' visible={Loading} showText='inMenu' locateInMenu='auto'>
              <LoadIndicator height={23} width={23} />
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='never' visible={(mode === 'new' || mode === 'update') && !Loading}>
              <Button id='toolBarSave' text={'Guardar'} stylingMode='outlined' icon={save} type='default' onClick={onSaveClick} />
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='never' visible={mode === 'view' && data['Cz_Id'] && !Loading}>
              <Button id='toolBarEdit' text={'Editar'} icon={EditIcon} stylingMode='outlined' type='default' onClick={handleEditClick} />
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='never' visible={mode === 'new' || mode === 'update'}>
              <Button id='toolBarCancel' text={'Cancelar'} stylingMode='outlined' icon='close' type='danger' onClick={onCancelClick} />
            </ItemToolBar>
          </Toolbar>
        </div>

        <ScrollView className='panelOrdenes' style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', paddingBottom: '50px' }}>
          <div className='form-container' style={{ height: '90px' }}>
            <Form className='plain-styled-form'>
              <GroupItem colCount={ColumnsOrdersCount ? parseInt(ColumnsOrdersCount) : 1}>
                <Item>
                  <TextBox label='No cotización' stylingMode='outlined' labelMode='static' value={data['Cz_Id'] || ''} readOnly={true} />
                </Item>
                {info && info.filter((x) => x.Dfc_Equivalencia === 'Ord_Cn_Id').length > 0 && (
                  <Item colSpan={1}>
                    <SelectBox label='Contrato' stylingMode='outlined' labelMode='static' value={data['Cz_Cn_Id'] || ''} searchEnabled={true} validationError={null} items={lstContratos} displayExpr='Cn_Nombre' valueExpr='Cn_Id' onValueChange={setData('Cz_Cn_Id', null)} readOnly={mode === 'view'} />
                  </Item>
                )}

                {info && info.filter((x) => x.Dfc_Equivalencia === 'Ord_Se_Id').length > 0 && (
                  <Item colSpan={1}>
                    <SelectBox label='Servicio' stylingMode='outlined' labelMode='static' value={data['Cz_Se_Id'] || ''} searchEnabled={true} validationError={null} items={lstServicios} displayExpr='Se_Nombre' valueExpr='Se_Id' onValueChange={setData('Cz_Se_Id', null)} readOnly={mode === 'view'} />
                  </Item>
                )}

                {info
                  ?.filter((x) => x.Dfc_Equivalencia !== 'Pc_Foto' && x.Dfc_Equivalencia !== 'Ord_Se_Id' && x.Dfc_Equivalencia !== 'Ord_Cn_Id' && x.TipoCampo.Tcm_Equivalencia !== 'dxTextArea')
                  .sort((x) => x.Dfc_Orden)
                  .map((x) => {
                    const currentDep = info.find((y) => x.Dfc_DependencyDefinition === y.Dfc_Id)?.Dfc_Equivalencia;
                    if (x.Dfc_Equivalencia === 'Ord_Sd_Id' && !AllowCreateOrdersAnotherLocation) {
                      return (
                        <Item key={x.Dfc_Id} colSpan={1}>
                          <CustomFormControl value={data[x.Dfc_Equivalencia]} data={x} onValueChange={setData(x.Dfc_Dinamico ? `AditionalFields.${x.Dfc_Equivalencia}` : x.Dfc_Equivalencia, x.Dfc_Cast)} isEditing={AllowCreateOrdersAnotherLocation} />
                        </Item>
                      );
                    }
                    return (
                      <Item key={x.Dfc_Id} colSpan={1}>
                        {/* Anterior <CustomFormControl valueDepency={x.Dfc_Dependency ? data[`${x.Dfc_Dinamico && 'AditionalFields.'}${currentDep}`] : undefined} value={x.Dfc_Dinamico ? data.AditionalFields[x.Dfc_Equivalencia] : data[x.Dfc_Equivalencia]} data={x} onValueChange={setData(x.Dfc_Dinamico ? `AditionalFields.${x.Dfc_Equivalencia}` : x.Dfc_Equivalencia, x.Dfc_Cast)} isEditing={mode === 'new' || mode === 'update'} /> */}
                        <CustomFormControl valueDepency={x.Dfc_Dependency && currentDep && data.AditionalFields ? data.AditionalFields[currentDep] : undefined} value={x.Dfc_Dinamico && data.AditionalFields ? data.AditionalFields[x.Dfc_Equivalencia] || null : data[x.Dfc_Equivalencia]} data={x} onValueChange={setData(x.Dfc_Dinamico ? `AditionalFields.${x.Dfc_Equivalencia}` : x.Dfc_Equivalencia, x.Dfc_Cast)} isEditing={mode === 'new' || mode === 'update'} />
                      </Item>
                    );
                  })}
              </GroupItem>
            </Form>
          </div>
        </ScrollView>
      </div>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#menuTraceabilityOrd'}>
        Trazabilidad
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#OrdClinicalData'}>
        Datos clínicos
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#filterButton'}>
        Filtrar
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarNew'}>
        Nuevo
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarEdit'}>
        Editar
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarDelete'}>
        Eliminar
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarSave'}>
        Guardar
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarCancel'}>
        Cancelar
      </Tooltip>
    </div>
  );
};

export default Index;
